import { createApp } from "vue";
import App from "./App.vue";
import "./css/styles.css";
import "./css/animations.css";

createApp(App).mount("#app");
